module.exports = __webpack_public_path__ + "img/chevron-bar-expand.110a3dfa.svg";